/**
 * Máscara progressiva de celular BR: (NN) NNNNN-NNNN.
 * Aceita qualquer entrada e devolve a melhor formatação possível pros dígitos já digitados.
 * Limita a 11 dígitos (DDD + 9 + 8 dígitos do número).
 */
export function formatPhoneBR(input: string): string {
  const digits = input.replace(/\D/g, '').slice(0, 11);
  if (digits.length === 0) return '';
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

/**
 * Formata pra exibição um número no formato E.164 brasileiro (+5511987654321).
 * Remove o +55 e devolve (NN) NNNNN-NNNN. Se o input for inválido, devolve o próprio input.
 */
export function displayPhoneBR(e164: string | null | undefined): string {
  if (!e164) return '';
  const digits = e164.replace(/\D/g, '');
  const local = digits.startsWith('55') ? digits.slice(2) : digits;
  return formatPhoneBR(local) || e164;
}
